export var AccountSection;
(function (AccountSection) {
    AccountSection["Assets"] = "assets";
    AccountSection["Payables"] = "payables";
    AccountSection["PartnersCapital"] = "partnersCapital";
    AccountSection["Income"] = "income";
    AccountSection["Expenses"] = "expenses";
})(AccountSection || (AccountSection = {}));
//# sourceMappingURL=schema.js.map